module.exports = __webpack_public_path__ + "assets/2a493d4b53e2cba90a9a6e1a9636c9af.svg";